// pages/LoginCallback.tsx
import { useEffect, useRef } from "react";
import api from "../services/api";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export const LoginCallback = () => {
  const navigate = useNavigate();
  const { checkAuthStatus } = useAuth();

  const hasRun = useRef(false);
  
  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    handleCodeExchange();
  }, [navigate]);

  const handleCodeExchange = async () => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("request_token");
    const state = params.get("state"); // This is the userId

    if (!code) {
      console.error("No authorization code found in the URL.");
      navigate("/login"); // Redirect to login on error
      return;
    }

    try {
      // Exchange the code for a server-side session
      const response = await api.post(
        "/auth/token",
        { code, state },
        { withCredentials: true } // Important: Allow cookies to be set
      );

      // If a JWT token was returned, save it
      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
        // Update global auth status
        await checkAuthStatus();
      }

      // After successful token exchange, simply redirect to dashboard
      navigate("/trade-dashboard");
    } catch (error: any) {
      console.error("Token exchange failed:", error);
      navigate("/login"); // Redirect to login on error
    }
  };

  return <h2>Logging you in...</h2>;
};
